var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('ArabicNumber',{attrs:{"number":_vm.finalAmount}}),_vm._v(" "),(_vm.withCurrency)?_c('span',[_vm._v("ريال")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }